export default "__VITE_ASSET__rAsehD9i__"